import bgImg from '@/assets/img/curved-images/curved9.jpg';
import { SessionLayout } from '@/components/layout/SessionLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useUpdatePasswordReset } from '@/hooks/api/0090_update_password_reset';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiErrorMessages } from '@/components/element/ApiErrorMessages';
import { useLoading } from '@/providers/LoadingProvider';
import { toastSuccess } from '@/lib/toast';

type FormInputs = {
  token: string;
  pin_code: string;
  password: string;
  password_confirmation: string;
};
export const PasswordReset = () => {
  const location = useLocation();
  const token: string = location.state?.token;
  const pin_code: string = location.state?.pin_code;
  const navigate = useNavigate();
  const { setShowLoading } = useLoading();

  const { mutate, isPending, isSuccess, error } = useUpdatePasswordReset();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<FormInputs>({
    mode: 'onBlur',
    criteriaMode: 'all',
    defaultValues: { token, pin_code },
  });

  useEffect(() => {
    if (token == null || pin_code == null) {
      navigate('/password_reset/new');
    }
  }, [token, pin_code]);

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (isSuccess) {
      toastSuccess('パスワードを再設定しました');
      navigate(`/sign_in`);
    }
  }, [isSuccess]);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    setShowLoading(true);
    mutate(data);
  };

  return (
    <SessionLayout>
      <main className="main-content mt-0">
        <div className="page-header min-vh-100" style={{ backgroundImage: `url(${bgImg})` }}>
          <span className="mask bg-gradient-dark opacity-6"></span>
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-7 mx-auto">
                <div className="card z-index-0 mt-sm-12 mt-9 mb-4">
                  <div className="card-header text-center pt-4 pb-1">
                    <h4 className="font-weight-bolder mb-1">New Password</h4>
                    <p className="mb-0">新しいパスワードを設定してください</p>
                  </div>
                  <div className="card-body">
                    <form role="form" className="text-start" onSubmit={handleSubmit(onSubmit)}>
                      <ApiErrorMessages error={error} />

                      <div className="mb-3">
                        <input
                          type="password"
                          maxLength={50}
                          className={`form-control ${errors.password && 'is-invalid'}`}
                          placeholder={'パスワード'}
                          aria-label="Password"
                          {...register('password', {
                            required: '入力して下さい。',
                            pattern: {
                              value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[!-~]{8,50}$/,
                              message: '半角英数・大文字小文字・記号を組み合わせて下さい。',
                            },
                          })}
                        />
                        {errors.password && <div className="text-xs text-danger mt-1">{errors.password.message}</div>}
                      </div>
                      <div className="mb-3">
                        <input
                          type="password"
                          maxLength={50}
                          className={`form-control ${errors.password_confirmation && 'is-invalid'}`}
                          placeholder={'パスワード（再設定）'}
                          aria-label="Re enter passoword"
                          {...register('password_confirmation', {
                            required: '入力して下さい。',
                            validate: (value) => value == getValues('password') || 'パスワードが一致しません。',
                          })}
                        />
                        {errors.password_confirmation && <div className="text-xs text-danger mt-1">{errors.password_confirmation.message}</div>}
                      </div>
                      <div className="text-center mb-3">
                        <button className="btn bg-gradient-dark btn-lg w-100">設定する</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </SessionLayout>
  );
};
